"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.styles = styles_1.createStyles({
    container: {
        width: 'fit-content',
        backgroundColor: '#fff',
        borderRadius: 5,
        padding: 20,
        fontFamily: 'Avenir Next, open sans, Arial',
    },
    variant_flat: {
        backgroundColor: '#f9f9f9',
        border: "1px solid #f0f0f0",
    },
});
